import { render, staticRenderFns } from "./ReportConfigDlg.vue?vue&type=template&id=50ba7a4c&scoped=true"
import script from "./ReportConfigDlg.vue?vue&type=script&lang=ts"
export * from "./ReportConfigDlg.vue?vue&type=script&lang=ts"
import style0 from "./ReportConfigDlg.vue?vue&type=style&index=0&id=50ba7a4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ba7a4c",
  null
  
)

export default component.exports